import React, { useContext, useEffect } from 'react'
import { IFilter, ISelectFilter } from 'react-angle-dashboard-components'
import { Directory } from '../../components/Directory'
import { IDirectoryProps } from 'react-angle-dashboard-components/dist/components/Directory'
import { useLocation } from 'react-router-dom'
import { providerService } from '../../services'
import { useHistory } from 'react-router-dom'
import { filters, getSpecialtyIndex } from './filters'
import { NavbarContext } from '../../components/Navbar/NavbarContext'
import routes from '../../routes/paths'
import { useQuery } from 'react-query'

const initialFilters: IFilter[] = filters

export const ProvidersDirectory: React.FC = () => {
  const { setBackInfo } = useContext(NavbarContext)

  const { data: specialties, isLoading } = useQuery(
    ['providerSpecialties'],
    () => providerService.getSpecialties()
  )

  useEffect(() => {
    setBackInfo({
      link: routes.care,
      text: 'Back to Angle'
    })
  }, [setBackInfo])

  const { googleApiKey } = (window as any).runtimeConfig
  const history = useHistory()

  const urlSearchParams = new URLSearchParams(useLocation().search)

  const filterBySpecialty = urlSearchParams.get('specialty')

  const lat = urlSearchParams.get('lat') || ''
  const lng = urlSearchParams.get('lng') || ''
  const nameFilter = urlSearchParams.get('query') || undefined

  if (specialties) {
    const specialtyIndex = getSpecialtyIndex()

    ;(initialFilters[specialtyIndex] as ISelectFilter).options = specialties

    initialFilters[specialtyIndex].value =
      filterBySpecialty?.replaceAll('AND', '&') || ''
  }

  let center
  if (lat && lng) {
    center = { lat: +lat, lng: +lng }
  }

  const navigateToProfile = (id: number | string) => {
    history.push(`/providers/${id}`)
  }

  const directoryConfig: IDirectoryProps = {
    initialFilters,
    googleApiKey,
    reactQueryConfig: {
      key: 'providers',
      asyncSearchFn: providerService.find.bind(providerService)
    },
    itemsName: 'Providers',
    emptySearchText: 'Please alter your search parameters to find providers.',
    emptySearchTitle: 'No results found.',
    markerIcon: 'icon-user',
    cardClickHandler: navigateToProfile,
    isProvider: true,
    initialCenter: center,
    initialNameFilter: nameFilter || undefined,
    navbarHeight: 145
  }

  return isLoading ? null : <Directory {...directoryConfig} />
}

export default ProvidersDirectory
